import React from 'react'
import DataTableComponentExample from '../../../Components/settings/TableExample/DataTableComponentExample'
function DataTableExample() {
    return (
        <DataTableComponentExample />
    )
}

export default DataTableExample